import { MARQUEE_ITEMS } from "@/data";

export default function Marquee() {
  const group = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl sm:text-3xl font-semibold uppercase tracking-wide text-stone-500 px-8">
            {item}
          </span>
          <span className="inline-block h-2.5 w-2.5 rotate-45 bg-amber-500" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="relative border-y border-stone-200 bg-[#F3EFE6] py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        {group(false)}
        {group(true)}
      </div>
    </div>
  );
}
